"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.roundKtoD = exports.exactFtInToCm = exports.roundedCmToFtIn = exports.exactMetersToMiles = exports.exactMilesToMeters = exports.exactCmtoInch = exports.exactInchtoCm = exports.exactKgtoLbs = exports.exactLbsToKg = exports.METERS_IN_MILE = exports.CM_IN_INCH = exports.POUNDS_IN_KG = void 0;
exports.POUNDS_IN_KG = 2.20462;
exports.CM_IN_INCH = 2.54;
exports.METERS_IN_MILE = 1609.34;
const exactLbsToKg = (value) => {
    return value / exports.POUNDS_IN_KG;
};
exports.exactLbsToKg = exactLbsToKg;
const exactKgtoLbs = (value) => {
    return value * exports.POUNDS_IN_KG;
};
exports.exactKgtoLbs = exactKgtoLbs;
const exactInchtoCm = (value) => {
    return value * exports.CM_IN_INCH;
};
exports.exactInchtoCm = exactInchtoCm;
const exactCmtoInch = (value) => {
    return value / exports.CM_IN_INCH;
};
exports.exactCmtoInch = exactCmtoInch;
const exactMilesToMeters = (value) => {
    return value * exports.METERS_IN_MILE;
};
exports.exactMilesToMeters = exactMilesToMeters;
const exactMetersToMiles = (meters) => {
    return meters / exports.METERS_IN_MILE;
};
exports.exactMetersToMiles = exactMetersToMiles;
const roundedCmToFtIn = (cm) => {
    const totalInches = (0, exports.exactCmtoInch)(cm);
    const feet = Math.floor(totalInches / 12);
    const inches = Math.round(totalInches % 12);
    if (inches === 12) {
        return { ft: feet + 1, in: 0 };
    }
    else {
        return { ft: feet, in: inches };
    }
};
exports.roundedCmToFtIn = roundedCmToFtIn;
const exactFtInToCm = (ftIn) => {
    const totalInches = ftIn.ft * 12 + ftIn.in;
    return Math.round((0, exports.exactInchtoCm)(totalInches));
};
exports.exactFtInToCm = exactFtInToCm;
/**
 * Round kilo- to deci- (e.g. kilograms/kg to decigrams/dg). Used for comparing
 * weight values in kg which may have originated in lbs.
 */
const roundKtoD = (value) => Math.round(value * 10000);
exports.roundKtoD = roundKtoD;
